import { PacoteCampanhaFilter } from './pacote-campanha-filter';

export class PacoteCampanhaFilterStorage {
    filter: PacoteCampanhaFilter;
    filterValues: Map<string, any>;

    constructor(filter: PacoteCampanhaFilter) {
        this.filter = filter;
        this.filterValues = new Map();
    }
}
